// Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#121827", padding: "10px", textAlign: "center", bottom: "0", width: "100%",color:"#E4B300" }}>
      <p>&copy; 2024 Zhihui Xu. All rights reserved.</p>
    </footer>
  );
};

export default Footer;